import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { Link } from "react-router";
import { ArrowForward } from "@mui/icons-material";

const ServiceWorldMyCasesNewCaseCard = () => {
  return (
    <Card
      elevation={4}
      sx={(theme) => ({
        backgroundColor: theme.palette.primaryPale,
        marginTop: 0,
        padding: "1.5rem",
      })}
    >
      <Grid container spacing={2} sx={{ alignItems: "center" }}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Box>
            <Typography variant={"cardTitle"}>Sie haben ein weiteres rechtliches Anliegen?</Typography>
            <Typography>Wir helfen Ihnen gerne weiter.</Typography>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 4 }}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-start", md: "flex-end" },
          }}
        >
          <Button
            variant="contained"
            component={Link}
            to={"/servicewelt/neuer-fall"}
            endIcon={<ArrowForward />}
            sx={{ whiteSpace: "nowrap", width: { xs: "100%", sm: "auto" } }}
          >
            Neuen Fall anlegen
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ServiceWorldMyCasesNewCaseCard;
